module.exports = __webpack_public_path__ + "static/img/微信二维码.ce4d005.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/微信二维码.png
// module id = mv+L
// module chunks = 1